import { cn } from "../lib/utils";


export function BrandName ({className}) {

  return (
    <div className={cn("flex items-center flex-col gap-12 mt-16 font-[Katibeh]")}>
      <h1 className={cn(className, "text-primary text-[100px]  leading-[0] m-0")}>DECIDE</h1>
      <h2 className={cn("text-secondary text-[80px] leading-[0] m-0")}>For Me</h2>
    </div>
  )
}
